import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class StandMileto extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/StandMileto/', 'StandMileto.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 1000)
      newMeshes[14].removeLODLevel(null) // La torre

    })
  }

}



// WEBPACK FOOTER //
// ./src/hobjects/StandMileto.js